import React, { useEffect, useState } from 'react';

import { getAllSections } from '../../actions/sections.action';
import SectionCard from '../_ui/SectionCard/SectionCard';
import SectionTitle from '../_ui/SectionTitle/SectionTitle';

const AllSections = () => {
    const [sections, setSections] = useState();
    const [langFilter, setLangFilter] = useState('all');

    const fetchSections = async () => {
        const fetchSections = await getAllSections();
        setSections(fetchSections);
    };
    useEffect(() => {
        fetchSections();

    }, []);

    const sectionsFiltered = langFilter === 'all'
        ? sections
        : sections?.filter(section => section.lang === langFilter);

    return (
        <>
            <SectionTitle
                image={ process.env.REACT_APP_SECTIONS_IMAGE }
                title="Secciones de tu web"
                instructions="Aquí verás todas las secciones que componen tu web. Pincha en cualquiera para editarla :). Si necesitas añadir una nueva sección, ponte en contacto con el webmaster."
            />
            <div style={ { display: 'flex', gap: '10px', marginBottom: '15px' } }>
                <button
                    className={ `my-btn mini ${langFilter === 'all' ? 'active' : ''}` }
                    onClick={ () => setLangFilter('all') }
                >
                    Todos
                </button>
                <button
                    className={ `my-btn mini ${langFilter === 'es' ? 'active' : ''}` }
                    onClick={ () => setLangFilter('es') }
                >
                    Español
                </button>
                <button
                    className={ `my-btn mini ${langFilter === 'en' ? 'active' : ''}` }
                    onClick={ () => setLangFilter('en') }
                >
                    English
                </button>
            </div>
            {
                sectionsFiltered?.length > 0 && (
                    <section className="all-sections">
                        { sectionsFiltered.map((st) => (
                            <SectionCard key={ st._id } section={ st } />
                        )) }
                    </section >
                )

            }
        </>
    );
};

export default AllSections;
